import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-housekeeping-order',
    templateUrl: './housekeeping-order.component.html',
    styleUrls: ['./housekeeping-order.component.css'],
    standalone: false
})
export class HousekeepingOrderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
